module.exports = __webpack_public_path__ + "static/revtel-logo-419515092d878425d0784934b331b4df.png";